"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.todos.completed': 'Completata',
    'tutorial.todos.pending': 'In sospeso',
    'tutorial.todos.markCompleted': 'Segna come completata',
    'tutorial.todos.markPending': 'Segna come in sospeso',
    'tutorial.todos.statusDone': 'completata',
    'tutorial.todos.statusUndone': 'non completata',
    'tutorial.todos.changeComment.1': "Hai cambiato lo stato dell'attività \"{name}\" in: {status}.",
    'tutorial.todos.changeComment.2': 'Attività "{name}" – {status}. Preso nota.',
    'tutorial.todos.changeComment.3': "Ho registrato la modifica: l'attività \"{name}\" ora è {status}.",
    'tutorial.todos.changeComment.4': 'Salvato! L\'attività "{name}" è segnata come {status}.',
    'tutorial.audio.stop': 'Ferma',
    'tutorial.audio.pause': 'Pausa',
    'tutorial.audio.play': 'Riproduci',
    'tutorial.audio.volume': 'Volume',
    'tutorial.audio.writingSpeed': 'Velocità di scrittura',
    'tutorial.audio.writingSpeed.normal': 'Normale',
    'tutorial.audio.writingSpeed.fast': 'Veloce',
    'tutorial.audio.writingSpeed.veryFast': 'Molto veloce',
};
